// extracted by mini-css-extract-plugin
export default {"main_div":"FieldControl_main_div__TgcUZ","form_div":"FieldControl_form_div__H8eBK"};